(() => {
  const normalizeMediaId = (value) => String(value ?? '').split('/').filter(Boolean).pop() ?? '';
  const finishOf = (variant) => String(variant?.finish ?? variant?.options?.Finish ?? '');
  const isSceneVariant = (variant) => finishOf(variant).includes(' + Scene');
  const filterSceneVariants = (variants) => (Array.isArray(variants) ? variants : []).filter((variant) => !isSceneVariant(variant));
  const findVariantById = (variants, id) => {
    const normalizedId = normalizeMediaId(id);
    return filterSceneVariants(variants).find((variant) => normalizeMediaId(variant.id) === normalizedId) ?? null;
  };
  const resolveInitialVariant = (variants, requestedId, serverInitialId) => {
    const safeVariants = filterSceneVariants(variants);
    return findVariantById(safeVariants, requestedId)
      ?? findVariantById(safeVariants, serverInitialId)
      ?? safeVariants.find((variant) => variant.available === true)
      ?? safeVariants[0]
      ?? null;
  };
  const resolveMedia = (media, mediaId) => {
    const normalizedId = normalizeMediaId(mediaId);
    if (!normalizedId) return null;
    return (Array.isArray(media) ? media : []).find((item) => normalizeMediaId(item.id) === normalizedId) ?? null;
  };
  const resolveStyleMediaState = ({
    usableMediaCount = 0,
    placeholderSrc = '',
    placeholderLabel = '',
    variant = null,
    media = [],
  } = {}) => {
    if (Number(usableMediaCount) === 0) {
      if (!placeholderSrc) return {kind: 'missing'};
      return {
        kind: 'placeholder',
        src: placeholderSrc,
        mobileSrc: placeholderSrc,
        label: placeholderLabel,
        mediaId: '',
      };
    }

    const resolved = resolveMedia(media, variant?.mediaId);
    if (!resolved) return {kind: 'missing'};
    return {
      kind: 'real',
      src: resolved.url,
      mobileSrc: resolved.mobileUrl || resolved.url,
      label: resolved.alt || '',
      mediaId: normalizeMediaId(resolved.id),
    };
  };
  const syncFinalArtworkTrigger = (
    trigger,
    {available = false, src = '', label = '', mediaId = ''} = {}
  ) => {
    if (!trigger) return;
    const image = trigger.querySelector('img');
    if (!available || !src) {
      trigger.hidden = true;
      trigger.disabled = true;
      trigger.setAttribute('aria-disabled', 'true');
      trigger.setAttribute('aria-pressed', 'false');
      trigger.classList.remove('is-active');
      delete trigger.dataset.previewSrc;
      delete trigger.dataset.previewLabel;
      delete trigger.dataset.previewMediaId;
      return;
    }

    trigger.hidden = false;
    trigger.disabled = false;
    trigger.removeAttribute('aria-disabled');
    const owner = trigger.closest?.('[data-venada-pdp]');
    owner?.querySelectorAll('[data-preview-trigger]').forEach((candidate) => {
      candidate.classList.toggle('is-active', candidate === trigger);
      candidate.setAttribute('aria-pressed', candidate === trigger ? 'true' : 'false');
    });
    trigger.classList.add('is-active');
    trigger.setAttribute('aria-pressed', 'true');
    trigger.dataset.previewSrc = src;
    trigger.dataset.previewLabel = label;
    const normalizedMediaId = normalizeMediaId(mediaId);
    if (normalizedMediaId) trigger.dataset.previewMediaId = normalizedMediaId;
    else delete trigger.dataset.previewMediaId;
    if (image) {
      image.src = src;
      image.alt = label;
    }
  };

  window.VenadaPdpLabHelpers = {
    filterSceneVariants,
    findVariantById,
    isSceneVariant,
    normalizeMediaId,
    resolveInitialVariant,
    resolveMedia,
    resolveStyleMediaState,
    syncFinalArtworkTrigger,
  };
})();
